import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  LinearProgress,
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
} from '@mui/material/';
import { green, red } from '@mui/material/colors';
import Modal from '@mui/material/Modal';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import moment, { tz } from 'moment-timezone';
import { WithTranslation, withTranslation } from 'react-i18next';
import { PumpStationDeviceInfo } from '../model/PumpStationDeviceInfo';

const SENSOR_1_FULL_HEIGHT = 91.41;
const SENSOR_1_ORIGIN_Y = 182.93;

const SENSOR_2_HEGIHT = 115.3;
const SENSOR_2_ORIGIN_Y = 493.9;

const activityColors = ['#6d97ab', '#4e8199', '#3a6c83', '#2b596f', '#3a6c83', '#4e8199'];
const overflowColors = [red[300], red[400], red[500], red[600], red[700], red[800]];

class SvgPOC extends React.Component<SvgPumpAssetProps, SvgPumpAssetState> {
  public state: SvgPumpAssetState = {
    sensor1Height: 0,
    sensor1Y: 0,
    towerPercentFilled: 0,
    sensor2Height: 0,
    sensor2Y: 0,
    groundPercentFilled: 0,
    activityColorIndex: 0,
    activityColorHex: activityColors[0],
    overflowColorHex: overflowColors[0],
    lastReading: 0,
  };

  public componentDidMount(): void {
    this.calculateWaterLevel();

    setInterval((): void => {
      this.changeActivityColorIndex();
    }, 200);
  }

  public componentDidUpdate = (prevProps: SvgPumpAssetProps): void => {
    if (prevProps.towerDevice.lastReadingValue !== this.props.towerDevice.lastReadingValue) {
      this.calculateWaterLevel();
    }
  };

  private changeActivityColorIndex = (): void => {
    let nextActivityColorIndex = this.state.activityColorIndex + 1;
    if (nextActivityColorIndex >= activityColors.length) {
      nextActivityColorIndex = 0;
    }
    this.setState({
      activityColorIndex: nextActivityColorIndex,
      activityColorHex: activityColors[nextActivityColorIndex],
      overflowColorHex: overflowColors[nextActivityColorIndex],
    });
  };

  private adjustDateForTimezone(date: Date | null, timezone: string | null): string {
    if (date === null || timezone === null) {
      return '';
    }

    const deviceUtcOffset = moment.tz(timezone).utcOffset();

    const tzOffset = -deviceUtcOffset * 60000;
    const adjustedDate = new Date(date.getTime() - tzOffset);
    return moment(adjustedDate).format('DD/MM/YYYY HH:MM:ss');
  }

  private calculateWaterLevel = (): void => {
    let towerLastReading = this.props.towerDevice.lastReadingValue || 0;

    let towerPercentFilled = (100 * towerLastReading) / this.props.towerContainerCapacity;
    if (towerPercentFilled < 30) {
      towerPercentFilled = 15;
    }
    const sensor1NewHeight = (SENSOR_1_FULL_HEIGHT / 100) * towerPercentFilled;
    const sensor1HeightDiff = SENSOR_1_FULL_HEIGHT - sensor1NewHeight;
    const sensor1YOffset = SENSOR_1_ORIGIN_Y + sensor1HeightDiff;

    let groundPercentFilled = 100 - towerPercentFilled;
    if (groundPercentFilled < 30) {
      groundPercentFilled = 30;
    }
    const sensor2NewHeight = (SENSOR_2_HEGIHT / 100) * groundPercentFilled;
    const sensor2HeightDiff = SENSOR_2_HEGIHT - sensor2NewHeight;
    const sensor2YOffset = SENSOR_2_ORIGIN_Y + sensor2HeightDiff;

    this.setState({
      sensor1Height: sensor1NewHeight,
      sensor1Y: sensor1YOffset,
      sensor2Height: sensor2NewHeight,
      sensor2Y: sensor2YOffset,
      towerPercentFilled: towerPercentFilled,
      groundPercentFilled: groundPercentFilled,
      lastReading: towerLastReading,
    });
  };

  private calculateTowerReading = (reading: number): number => {
    return reading;
  };

  private calculateGroundReading = (reading: number): number => {
    const towerReading = reading;
    const max = this.props.towerContainerCapacity;
    return max - towerReading;
  };

  public render(): React.ReactNode {
    return (
      <>
        <div
          style={{ position: 'relative', display: 'inline-block', width: '100%', height: 'auto' }}
        >
          {false && (
            <div style={{ position: 'absolute', left: '1%', top: '30%' }}>
              <Switch checked={this.props.relaySwitchStatus} onChange={(): void => {}} />
            </div>
          )}

          <svg
            width="100%"
            height="auto"
            viewBox="0 0 1300 630"
            xmlns="http://www.w3.org/2000/svg"
            stroke="null"
          >
            <g stroke="null">
              <line
                fill="none"
                stroke-width="8"
                x1="191.13688"
                y1="368.71607"
                x2="191.13688"
                y2="341.02951"
                id="svg_28"
                stroke="#ff5656"
              />
              <line
                transform="rotate(90 843.499 444.703)"
                stroke="url(#svg_159)"
                fill="none"
                stroke-width="10"
                x1="787.24633"
                y1="444.45981"
                x2="899.75076"
                y2="444.94525"
                id="svg_160"
              />
              <line
                transform="rotate(90 360.012 380.963)"
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff7c7c'}
                fill="none"
                stroke-width="10"
                x1="326.16454"
                y1="380.96235"
                x2="393.85866"
                y2="380.96235"
                id="svg_56"
              />
              <line
                stroke="#7f0000"
                id="svg_126"
                y2="497.43364"
                x2="70.15523"
                y1="478.05379"
                x1="89.53509"
                stroke-width="6"
                fill="none"
              />
              <line
                transform="rotate(90 227.907 486.194)"
                stroke="#7f0000"
                id="svg_127"
                y2="495.88325"
                x2="218.2173"
                y1="476.5034"
                x1="237.59715"
                stroke-width="6"
                fill="none"
              />
              <line
                stroke={'#000000'}
                fill="none"
                stroke-width="10"
                x1="233.22932"
                y1="420.71396"
                x2="280.61355"
                y2="420.71396"
                id="svg_21"
              />
              <ellipse
                stroke="#7f0000"
                fill="#ffffff"
                stroke-width="6"
                cx="154.49876"
                cy="420.46"
                id="svg_125"
                rx="83.11919"
                ry="57.10343"
              />
              <rect
                stroke="#c48157"
                style={{ vectorEffect: 'non-scaling-stroke' }}
                fill="#9ACEE6"
                stroke-width="0"
                x="934.46473"
                y={this.state.sensor1Y}
                width="128.73611"
                height={this.state.sensor1Height}
                id="svg_96"
                onClick={(): void => {}}
              />
              <rect
                stroke="#c48157"
                style={{ vectorEffect: 'non-scaling-stroke' }}
                fill="#9ACEE6"
                stroke-width="0"
                x="464.73015"
                y={this.state.sensor2Y}
                width="220.03177"
                height={this.state.sensor2Height}
                id="svg_55"
                onClick={(): void => {}}
              />
              <line
                stroke="#ff5656"
                fill="none"
                x1="0.11173"
                y1="499.65612"
                x2="461.42459"
                y2="499.65612"
                id="svg_1"
                stroke-width="10"
              />
              <line
                transform="rotate(89.7372 457.253 559.996)"
                stroke="#ff5656"
                fill="none"
                x1="394.05491"
                y1="559.99608"
                x2="520.45097"
                y2="559.99608"
                id="svg_3"
                stroke-width="10"
              />
              <line
                stroke="#ff5656"
                fill="none"
                x1="459.63129"
                y1="617.66171"
                x2="697.29048"
                y2="617.66171"
                id="svg_4"
                stroke-width="10"
              />
              <line
                transform="rotate(89.7372 692.386 553.891)"
                stroke="#ff5656"
                fill="none"
                x1="633.20855"
                y1="553.89105"
                x2="751.56342"
                y2="553.89105"
                id="svg_5"
                stroke-width="10"
              />
              <line
                stroke="#ff5656"
                fill="none"
                x1="690.70394"
                y1="499.65612"
                x2="1291.4924"
                y2="499.65612"
                id="svg_6"
                stroke-width="10"
              />
              <ellipse
                stroke="url(#svg_137)"
                fill="url(#svg_136)"
                stroke-width="10"
                cx="402.94845"
                cy="428.98713"
                id="svg_7"
                rx="46.29748"
                ry="41.59955"
              />
              <rect
                stroke="#7f0000"
                fill="#ffffff"
                stroke-width="6"
                x="89.12849"
                y="362.48864"
                width="131.21787"
                height="117.40413"
                id="svg_8"
              />
              <rect
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x="100.91195"
                y="374.63394"
                width="108.18653"
                height="95.89636"
                id="svg_10"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="101.46893"
                y1="402.02877"
                x2="207.36517"
                y2="402.02877"
                id="svg_11"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="101.73286"
                y1="413.42445"
                x2="207.62911"
                y2="413.42445"
                id="svg_12"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="101.73286"
                y1="425.58316"
                x2="208.26202"
                y2="425.58316"
                id="svg_13"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="101.73286"
                y1="439.64059"
                x2="208.26202"
                y2="439.64059"
                id="svg_14"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="101.91735"
                y1="387.42683"
                x2="207.81361"
                y2="387.42683"
                id="svg_15"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="102.80882"
                y1="454.97255"
                x2="208.64178"
                y2="454.97255"
                id="svg_16"
              />
              <rect
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x="281.4883"
                y="402.68793"
                width="26.84486"
                height="36.0488"
                id="svg_17"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="294.63257"
                y1="403.60738"
                x2="294.63257"
                y2="437.22382"
                id="svg_18"
              />
              <line
                stroke={this.props.relaySwitchStatus ? '#000000' : '#E9ECEF'}
                fill="none"
                stroke-width="10"
                x1="309.86064"
                y1="420.61887"
                x2="354.31583"
                y2="420.61887"
                id="svg_23"
              />
              <line
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff5656'}
                fill="none"
                stroke-width="10"
                x1="442.21988"
                y1="447.10667"
                x2="501.26107"
                y2="447.59211"
                id="svg_25"
              />
              <line
                transform="rotate(90 496.199 511.044)"
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff5656'}
                fill="none"
                stroke-width="10"
                x1="430.36702"
                y1="510.80071"
                x2="562.03093"
                y2="511.28614"
                id="svg_26"
              />
              <line
                transform="rotate(90 210.957 343.765)"
                stroke="#ff5656"
                fill="none"
                stroke-width="8"
                x1="210.95707"
                y1="366.22288"
                x2="210.95707"
                y2="321.30621"
                id="svg_29"
              />
              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="8"
                x1="230.94396"
                y1="346.81515"
                x2="230.94396"
                y2="277.43648"
                id="svg_30"
              />
              <rect
                stroke="#ff5656"
                fill="none"
                stroke-width="8"
                x="161.31789"
                y="183.40761"
                width="93.84987"
                height="91.78723"
                id="svg_31"
              />
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="172.68618"
                y1="352.58245"
                x2="172.68618"
                y2="279.30007"
                id="svg_35"
              />
              <line
                transform="rotate(90 121.556 348.489)"
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="121.55555"
                y1="404.22568"
                x2="121.55555"
                y2="292.75176"
                id="svg_36"
              />
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="69.2278"
                y1="352.6456"
                x2="69.2278"
                y2="324.025"
                id="svg_37"
              />
              <rect
                stroke="#ff5656"
                stroke-width="4"
                fill="none"
                x="46.77897"
                y="256.31495"
                width="49.58381"
                height="65.48806"
                id="svg_38"
              />
              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="68.50736"
                y1="255.12558"
                x2="68.50736"
                y2="53.42542"
                id="svg_40"
              />
              <line
                transform="rotate(90 99.2165 58.2593)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="99.21649"
                y1="86.44179"
                x2="99.21649"
                y2="30.07697"
                id="svg_41"
              />
              <ellipse
                stroke="null"
                fill="#ff5656"
                stroke-width="5"
                cx="129.02009"
                cy="58.14885"
                id="svg_42"
                rx="10"
                ry="10"
              />
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="231.13381"
                y1="180.65757"
                x2="231.13381"
                y2="154.44518"
                id="svg_43"
              />
              <line
                transform="rotate(90 432.749 156.689)"
                fill="none"
                stroke-width="10"
                x1="432.74927"
                y1="363.35953"
                x2="432.74927"
                y2="-49.98207"
                id="svg_44"
                stroke="#6D97AB"
              />
              <line
                fill="none"
                stroke-width="10"
                x1="643.30647"
                y1="576.91934"
                x2="643.30647"
                y2="151.44518"
                id="svg_45"
                stroke="#6D97AB"
              />
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_level_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.groundPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="14"
                  x1="628.66527"
                  y1="570.25671"
                  x2="658.36498"
                  y2="570.25671"
                  id="svg_48"
                />
              </Tooltip>
              <rect
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x="344.89949"
                y="324.35328"
                width="29.57556"
                height="22.69725"
                id="svg_58"
              />
              <line
                stroke="#7f0000"
                fill="none"
                stroke-width="3"
                x1="346.15851"
                y1="336.06687"
                x2="373.94595"
                y2="336.06687"
                id="svg_60"
              />
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="173.27726"
                y1="179.59464"
                x2="173.27726"
                y2="111.89127"
                id="svg_61"
              />
              <line
                transform="rotate(90 977.273 74.8419)"
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="977.27299"
                y1="138.59306"
                x2="977.27299"
                y2="11.09062"
                id="svg_62"
              />
              <text
                stroke="#005fbf"
                fill="#000000"
                stroke-width="0"
                x="40.42244"
                y="46.379"
                id="svg_63"
                font-size="14"
                font-family="'Montserrat'"
                text-anchor="start"
                xmlSpace="preserve"
                font-weight="bold"
              >
                {this.props.t<string>('pump_svg_power_supply')}
              </text>
              <rect
                stroke="#ff5656"
                stroke-width="2"
                fill="none"
                x="52.02195"
                y="263.84827"
                width="38.71419"
                height="34.66434"
                id="svg_65"
              />
              <rect
                stroke="#ff5656"
                stroke-width="2"
                fill="none"
                x="72.64652"
                y="306.38396"
                width="17.35969"
                height="9.01696"
                id="svg_66"
              />
              <text
                stroke="#005fbf"
                fill="#000000"
                stroke-width="0"
                x="456.29819"
                y="431.11706"
                id="svg_70"
                font-size="16"
                font-family="'Montserrat'"
                text-anchor="start"
                xmlSpace="preserve"
                font-weight="bold"
              >
                {this.props.t<string>('pump_svg_pump')}
              </text>
              <line
                transform="rotate(90 360.174 228.635)"
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#e9ecef'}
                fill="none"
                stroke-width="10"
                x1="266.36251"
                y1="228.39264"
                x2="453.98607"
                y2="228.87807"
                id="svg_71"
              />
              <line
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#e9ecef'}
                fill="none"
                stroke-width="10"
                x1="355.4835"
                y1="134.36161"
                x2="963.30614"
                y2="134.84705"
                id="svg_72"
              />
              <line
                transform="rotate(90 957.77 190.813)"
                stroke={this.props.relaySwitchStatus ? this.state.activityColorHex : '#e9ecef'}
                fill="none"
                stroke-width="10"
                x1="899.01386"
                y1="190.57048"
                x2="1016.52574"
                y2="191.05592"
                id="svg_73"
              />
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="1037.82785"
                y1="252.31983"
                x2="1037.82785"
                y2="70.63944"
                id="svg_74"
              />
              <line
                transform="rotate(90 927.225 231.121)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="878.3437"
                y1="230.87792"
                x2="976.10526"
                y2="231.36336"
                id="svg_75"
              />
              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="921.74233"
                y1="280.94504"
                x2="1074.86944"
                y2="281.43048"
                id="svg_76"
              />
              <line
                transform="rotate(90 1069.81 232.002)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="1019.87029"
                y1="231.75918"
                x2="1119.7445"
                y2="232.24461"
                id="svg_77"
              />
              <line
                transform="rotate(99.7199 927.53 387.443)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="817.05481"
                y1="387.15796"
                x2="1038.0056"
                y2="387.72694"
                id="svg_78"
              />
              <line
                transform="rotate(-100 1069.99 390.687)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="960.09705"
                y1="390.40789"
                x2="1179.89227"
                y2="390.96653"
                id="svg_79"
              />
              <line
                transform="rotate(-123.153 1016.51 388.171)"
                stroke="#ff5656"
                fill="none"
                x1="889.06479"
                y1="387.92795"
                x2="1143.94621"
                y2="388.41339"
                id="svg_80"
                stroke-width="10"
              />
              <line
                transform="rotate(124.47 980.612 389.856)"
                stroke="#ff5656"
                fill="none"
                x1="855.601"
                y1="389.61329"
                x2="1105.62279"
                y2="390.09873"
                id="svg_81"
                stroke-width="10"
              />
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_level_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.towerPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="13"
                  x1="1022.3534"
                  y1="257.10093"
                  x2="1051.8453"
                  y2="257.10093"
                  id="svg_82"
                />
              </Tooltip>
              <line
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="983.33026"
                y1="204.4013"
                x2="983.33026"
                y2="74.99285"
                id="svg_91"
              />
              <line
                transform="rotate(-90.3708 973.903 200.317)"
                stroke="#6D97AB"
                fill="none"
                stroke-width="10"
                x1="973.90327"
                y1="214.5945"
                x2="973.90327"
                y2="186.03878"
                id="svg_92"
              />
              <Tooltip
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_dry_run_sensor')}
                  </Typography>
                }
              >
                <ellipse
                  stroke="#6d97ab"
                  fill={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.towerPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  stroke-width="4"
                  cx="957.52643"
                  cy="200.82703"
                  id="svg_93"
                  rx="10"
                  ry="10"
                  stroke-opacity="0"
                />
              </Tooltip>

              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="878.94105"
                y1="262.58935"
                x2="925.36107"
                y2="263.07479"
                id="svg_97"
              />
              <line
                transform="rotate(90 883.649 359.009)"
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="790.88109"
                y1="358.7657"
                x2="976.41753"
                y2="359.25114"
                id="svg_99"
              />
              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="10"
                x1="788.19958"
                y1="449.08647"
                x2="888.49349"
                y2="449.57191"
                id="svg_100"
              />
              <line
                transform="rotate(90 742.721 447.028)"
                stroke="url(#svg_159)"
                fill="none"
                stroke-width="10"
                x1="686.4711"
                y1="446.78539"
                x2="798.97553"
                y2="447.27083"
                id="svg_102"
              />
              <line
                transform="rotate(82.8986 821.646 367.591)"
                stroke="#7f0000"
                fill="none"
                stroke-width="10"
                x1="784.96614"
                y1="395.37399"
                x2="858.32535"
                y2="339.80755"
                id="svg_106"
              />
              <ellipse
                stroke="#7f0000"
                fill="none"
                stroke-width="2"
                cx="790.53914"
                cy="380.18346"
                id="svg_107"
                rx="6.25792"
                ry="6.25792"
              />
              <line
                stroke="#ff5656"
                fill="none"
                stroke-width="6"
                x1="788.98194"
                y1="451.26738"
                x2="776.30591"
                y2="451.26738"
                id="svg_110"
              />
              <line
                transform="rotate(90 777.403 453.966)"
                stroke="#ff5656"
                fill="none"
                stroke-width="6"
                x1="783.22926"
                y1="453.96545"
                x2="771.57739"
                y2="453.96545"
                id="svg_111"
              />
              <ellipse
                stroke="#ff5656"
                fill="none"
                stroke-width="3"
                cx="781.14163"
                cy="444.97048"
                id="svg_112"
                rx="2.64084"
                ry="0.70422"
              />
              <text
                transform="rotate(-90 145.485 241.069)"
                stroke="#c48157"
                fill="#000000"
                stroke-width="0"
                x="67.81409"
                y="245.99948"
                id="svg_114"
                font-size="14"
                font-family="'Montserrat'"
                text-anchor="start"
                xmlSpace="preserve"
                font-weight="bold"
              >
                {this.props.t<string>('pump_svg_water_level_controller')}
              </text>
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_pump_off_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.groundPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="14"
                  x1="628.66527"
                  y1="550.58453"
                  x2="658.36498"
                  y2="550.58453"
                  id="svg_2"
                />
              </Tooltip>
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_pump_on_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.groundPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="14"
                  x1="628.66527"
                  y1="530.09266"
                  x2="658.36498"
                  y2="530.09266"
                  id="svg_9"
                />
              </Tooltip>
              <line
                transform="rotate(171.426 763.899 367.591)"
                stroke="#7f0000"
                fill="none"
                stroke-width="10"
                x1="727.21975"
                y1="395.37399"
                x2="800.57897"
                y2="339.80755"
                id="svg_19"
              />
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_pump_on_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.towerPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="13"
                  x1="1022.3534"
                  y1="237.38265"
                  x2="1051.8453"
                  y2="237.38265"
                  id="svg_20"
                />
              </Tooltip>
              <Tooltip
                placement="left"
                title={
                  <Typography variant="body1">
                    {this.props.t<string>('pump_svg_pump_off_sensor')}
                  </Typography>
                }
              >
                <line
                  stroke={
                    this.props.towerDevice.lastReadingValue
                      ? this.state.towerPercentFilled >= 100
                        ? this.state.overflowColorHex
                        : this.state.activityColorHex
                      : '#6d97ab'
                  }
                  fill="none"
                  stroke-width="13"
                  x1="1022.3534"
                  y1="217.66437"
                  x2="1051.8453"
                  y2="217.66437"
                  id="svg_22"
                />
              </Tooltip>
              <path
                stroke="#c48157"
                id="svg_33"
                d="m1114.10293,313.15911l0.56913,0l0.17587,-0.54067l0.17587,0.54067l0.56913,0l-0.46044,0.33415l0.17588,0.54067l-0.46044,-0.33416l-0.46044,0.33416l0.17588,-0.54067l-0.46044,-0.33415z"
                stroke-width="0"
                fill="#000000"
              />
              <text
                stroke="#000000"
                font-weight="bold"
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="14"
                id="svg_59"
                y="545.31347"
                x="708.22427"
                stroke-width="0"
                fill="#000000"
              >
                Нивомер - помпена станция
              </text>
              <ellipse
                stroke="null"
                fill="#6D97AB"
                stroke-width="10"
                cx="173.18841"
                cy="120.84742"
                id="svg_68"
                rx="10"
                ry="10"
              />
              <g stroke="null" id="svg_104">
                <path
                  stroke="null"
                  fill="currentColor"
                  d="m849.3104,65.43754c-8.95387,-8.28171 -22.87971,-8.27868 -31.83004,0c-0.33658,0.31132 -0.34315,0.83844 -0.01768,1.16137l1.73043,1.71679c0.3103,0.30828 0.80962,0.31486 1.13206,0.01921c7.37455,-6.75596 18.76487,-6.75748 26.14094,0c0.32243,0.29565 0.82176,0.28857 1.13206,-0.01921l1.73043,-1.71679c0.32496,-0.32294 0.31839,-0.85005 -0.01819,-1.16137zm-15.91502,9.96212c-1.78652,0 -3.23445,1.44792 -3.23445,3.23445s1.44793,3.23445 3.23445,3.23445s3.23445,-1.44792 3.23445,-3.23445s-1.44792,-3.23445 -3.23445,-3.23445zm10.2426,-4.2245c-5.82505,-5.15137 -14.66672,-5.14581 -20.4852,0c-0.34872,0.30828 -0.35984,0.84348 -0.02881,1.16996l1.74054,1.7178c0.30324,0.29918 0.79143,0.3194 1.11438,0.04042c4.24268,-3.66756 10.5999,-3.65947 14.83249,0c0.32294,0.27898 0.81114,0.25927 1.11437,-0.04042l1.74054,-1.7178c0.33154,-0.32648 0.31991,-0.86218 -0.0283,-1.16996z"
                  id="svg_101"
                />
              </g>
              <ellipse
                stroke="null"
                fill="#6D97AB"
                stroke-width="10"
                cx="910.36049"
                cy="75.53942"
                id="svg_108"
                rx="10"
                ry="10"
              />
              <g stroke="null" id="svg_113">
                <path
                  stroke="null"
                  fill="currentColor"
                  d="m192.25892,88.85312c-10.51661,-9.72714 -26.87296,-9.72358 -37.38542,0c-0.39533,0.36566 -0.40304,0.98477 -0.02077,1.36407l2.03245,2.01642c0.36446,0.36209 0.95093,0.36981 1.32964,0.02256c8.66165,-7.9351 22.03995,-7.93688 30.70338,0c0.37871,0.34725 0.96518,0.33894 1.32964,-0.02256l2.03245,-2.01642c0.38168,-0.3793 0.37396,-0.99841 -0.02137,-1.36407zm-18.69271,11.70083c-2.09833,0 -3.79897,1.70063 -3.79897,3.79897s1.70064,3.79897 3.79897,3.79897s3.79897,-1.70063 3.79897,-3.79897s-1.70063,-3.79897 -3.79897,-3.79897zm12.03027,-4.96181c-6.84171,-6.05045 -17.22654,-6.04392 -24.06053,0c-0.40958,0.36209 -0.42264,0.9907 -0.03384,1.37416l2.04432,2.01761c0.35616,0.3514 0.92956,0.37515 1.30887,0.04748c4.98317,-4.30767 12.44993,-4.29817 17.42124,0c0.3793,0.32767 0.95271,0.30452 1.30886,-0.04748l2.04432,-2.01761c0.3894,-0.38346 0.37574,-1.01266 -0.03324,-1.37416z"
                  id="svg_109"
                />
              </g>
              {this.props.towerDevice.lastReadingValue !== null && (
                <line
                  transform="rotate(90 493.113 74.7414)"
                  stroke="#6D97AB"
                  fill="none"
                  stroke-width="3"
                  x1="493.11333"
                  y1="391.91903"
                  x2="493.11333"
                  y2="-242.43618"
                  id="svg_121"
                  stroke-dasharray={this.state.activityColorIndex % 2 ? '2,2' : '2,3'}
                />
              )}
              <text
                stroke="#c48157"
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="9"
                id="svg_84"
                y="521.67759"
                x="708.63695"
                stroke-width="0"
                fill="#000000"
              >
                {this.props.t<string>('pump_svg_last_updated', {
                  timestamp: this.adjustDateForTimezone(
                    this.props.towerDevice.lastReadingDate,
                    this.props.towerDevice.timezone
                  ),
                })}
              </text>
              <text
                stroke="#000000"
                font-weight="bold"
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="14"
                id="svg_98"
                y="240.75861"
                x="1084.22465"
                stroke-width="0"
                fill="#000000"
              >
                {this.props.towerDevice.analogSensorName}
              </text>
              <text
                stroke="#c48157"
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="9"
                id="svg_118"
                y="215.47594"
                x="1084.60606"
                stroke-width="0"
                fill="#000000"
              >
                {this.props.t<string>('pump_svg_last_updated', {
                  timestamp: this.adjustDateForTimezone(
                    this.props.towerDevice.lastReadingDate,
                    this.props.towerDevice.timezone
                  ),
                })}
              </text>
              <text
                stroke="#ff5656"
                font-weight="bold"
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="12"
                id="svg_123"
                y="283.86863"
                x="58.15912"
                stroke-width="0"
                fill={this.props.relaySwitchStatus ? green[600] : red[500]}
              >
                {this.props.relaySwitchStatus ? 'ON' : 'OFF'}
              </text>
              <line
                stroke="#7f0000"
                id="svg_128"
                y2="491.23209"
                x2="219.76768"
                y1="492.00728"
                x1="90.31028"
                stroke-width="2"
                fill="none"
              />
              <line
                stroke="#7f0000"
                id="svg_129"
                y2="488.9065"
                x2="107.36455"
                y1="488.9065"
                x1="90.31028"
                stroke-width="6"
                fill="none"
              />
              <line
                stroke="#7f0000"
                id="svg_130"
                y2="488.9065"
                x2="220.54288"
                y1="488.9065"
                x1="203.48861"
                stroke-width="6"
                fill="none"
              />
              <g stroke="null" id="svg_27" stroke-width="8">
                <path
                  stroke="null"
                  id="svg_32"
                  fill="#cecece"
                  d="m592.82097,56.01774c1.12802,-2.02462 1.76082,-4.23844 1.76082,-6.54689c0,-10.02846 -11.83049,-18.16478 -26.41226,-18.16478c-5.42002,0 -10.48237,1.13529 -14.66431,3.0653c-7.62104,-9.08239 -21.84514,-15.17515 -38.16022,-15.17515c-24.32129,0 -44.02044,13.5479 -44.02044,30.27462c0,0.51089 0.02751,1.02177 0.05503,1.53266c-15.40715,3.72757 -26.46729,13.83172 -26.46729,25.7145c0,15.04271 17.74574,27.24716 39.6184,27.24716l101.24701,0c19.45153,0 35.21635,-10.8421 35.21635,-24.21971c0,-11.71249 -12.10562,-21.49499 -28.17308,-23.72774l-0.00001,0.00002z"
                />
              </g>
              <g stroke="null" id="svg_34">
                <g stroke="null" id="svg_39">
                  <path
                    stroke="null"
                    id="svg_46"
                    d="m491.52369,75.96978c0,1.88125 0,3.42873 0.09103,4.26315c0.06068,0.57651 0.18205,1.00131 0.75857,1.07716c0.27308,0.04552 0.71305,0.07585 0.87994,0.07585c0.12137,0 0.15172,0.06068 0.15172,0.12137c0,0.09103 -0.09103,0.15172 -0.3186,0.15172c-1.07716,0 -2.32122,-0.06068 -2.41224,-0.06068c-0.09103,0 -1.33508,0.06068 -1.92676,0.06068c-0.2124,0 -0.3186,-0.04552 -0.3186,-0.15172c0,-0.06068 0.04552,-0.12137 0.15172,-0.12137c0.18205,0 0.40962,-0.04552 0.59169,-0.07585c0.39445,-0.07585 0.48549,-0.51582 0.57651,-1.07716c0.09103,-0.81925 0.09103,-2.3819 0.09103,-4.26315l0,-8.29872c-0.95579,0.01517 -1.94193,0.01517 -2.89772,0.04552c-1.21371,0.01517 -1.68402,0.15172 -2.00262,0.62202c-0.2124,0.33377 -0.27308,0.47032 -0.33377,0.60685c-0.06068,0.15172 -0.12137,0.19722 -0.19722,0.19722c-0.06068,0 -0.09103,-0.06068 -0.09103,-0.18205c0,-0.19722 0.39445,-1.88125 0.4248,-2.04813c0.04552,-0.12137 0.12137,-0.37929 0.19722,-0.37929c0.13655,0 0.33377,0.19722 0.86477,0.24274c0.57651,0.06068 1.31991,0.09103 1.54748,0.09103l7.38844,0c0.62202,0 1.07716,-0.04552 1.39576,-0.09103c0.28825,-0.04552 0.47032,-0.09103 0.54617,-0.09103c0.09103,0 0.09103,0.12137 0.09103,0.24274c0,0.59169 -0.06068,1.94193 -0.06068,2.15433c0,0.18205 -0.06068,0.25792 -0.13655,0.25792c-0.09103,0 -0.13655,-0.06068 -0.15172,-0.33377c0,-0.07585 -0.01517,-0.13655 -0.01517,-0.2124c-0.06068,-0.59169 -0.531,-1.04682 -2.41224,-1.07716c-0.81925,-0.01517 -1.65368,-0.01517 -2.47292,-0.04552l0,8.29872l-0.00001,0z"
                  />
                  <path
                    stroke="null"
                    id="svg_49"
                    d="m509.0921,74.30094c0.06068,0 0.12137,0 0.12137,-0.09103l0,-0.34894c0,-2.5943 0,-3.04944 -0.04552,-3.56526c-0.04552,-0.531 -0.12137,-0.80409 -0.75857,-0.92546c-0.13655,-0.01517 -0.33377,-0.04552 -0.48549,-0.04552c-0.13655,0 -0.24274,-0.06068 -0.24274,-0.13655c0,-0.12137 0.09103,-0.13655 0.27308,-0.13655c0.81925,0 1.98745,0.06068 2.0633,0.06068c0.07585,0 1.18336,-0.06068 1.75988,-0.06068c0.19722,0 0.3186,0.01517 0.3186,0.13655c0,0.06068 -0.06068,0.13655 -0.2124,0.13655c-0.12137,0 -0.27308,0.01517 -0.39445,0.04552c-0.531,0.07585 -0.60685,0.39445 -0.65237,0.94062c-0.01517,0.531 -0.01517,0.98614 -0.01517,3.56526l0,2.94324c0,1.60816 0,2.88256 0.07585,3.59561c0.06068,0.47032 0.15172,0.86477 0.66754,0.92546c0.25792,0.04552 0.51582,0.06068 0.68271,0.06068c0.15172,0 0.25792,0.06068 0.25792,0.13655c0,0.09103 -0.09103,0.13655 -0.28825,0.13655c-0.98614,0 -2.12399,-0.06068 -2.21502,-0.06068c-0.07585,0 -1.21371,0.06068 -1.7447,0.06068c-0.19722,0 -0.28825,-0.04552 -0.28825,-0.15172c0,-0.06068 0.06068,-0.12137 0.2124,-0.12137c0.15172,0 0.28825,0 0.45514,-0.04552c0.33377,-0.06068 0.4248,-0.48549 0.48549,-0.94062c0.09103,-0.71305 0.09103,-1.94193 0.09103,-3.53493l0,-1.7447c0,-0.07585 -0.06068,-0.12137 -0.12137,-0.12137l-7.13053,0c-0.06068,0 -0.09103,0.01517 -0.09103,0.12137l0,1.7447c0,1.59299 0,2.86739 0.09103,3.56526c0.06068,0.4248 0.15172,0.81925 0.66754,0.87994c0.25792,0.04552 0.54617,0.06068 0.71305,0.06068c0.13655,0 0.24274,0.06068 0.24274,0.13655s-0.07585,0.13655 -0.25792,0.13655c-1.00131,0 -2.15433,-0.06068 -2.26053,-0.06068c-0.06068,0 -1.25921,0.06068 -1.75988,0.06068c-0.19722,0 -0.3186,-0.04552 -0.3186,-0.13655c0,-0.06068 0.04552,-0.13655 0.2124,-0.13655c0.15172,0 0.3186,-0.01517 0.47032,-0.06068c0.34894,-0.07585 0.4248,-0.45514 0.48549,-0.87994c0.12137,-0.71305 0.09103,-2.01779 0.09103,-3.62595l0,-2.91289c0,-2.5943 0,-3.09496 -0.04552,-3.62595c-0.04552,-0.51582 -0.18205,-0.87994 -0.74339,-0.94062c-0.18205,-0.01517 -0.37929,-0.04552 -0.531,-0.04552c-0.13655,0 -0.2124,-0.06068 -0.2124,-0.12137c0,-0.12137 0.09103,-0.13655 0.28825,-0.13655c0.84959,0 1.79022,0.06068 2.04813,0.06068c0.07585,0 1.21371,-0.06068 1.75988,-0.06068c0.19722,0 0.28825,0.04552 0.28825,0.13655c0,0.07585 -0.07585,0.12137 -0.19722,0.12137s-0.18205,0 -0.39445,0.04552c-0.48549,0.07585 -0.60685,0.40962 -0.65237,0.95579c-0.01517,0.531 -0.01517,0.95579 -0.01517,3.55009l0,0.34894c0,0.09103 0.06068,0.09103 0.12137,0.09103l7.13053,0l0,0.01517l0,0.00003z"
                  />
                  <path
                    stroke="null"
                    id="svg_50"
                    d="m516.85983,73.87615c0,-2.5943 0,-3.06461 -0.04552,-3.59561c-0.04552,-0.531 -0.15172,-0.81925 -0.57651,-0.91028c-0.19722,-0.04552 -0.33377,-0.04552 -0.45514,-0.06068c-0.13655,-0.01517 -0.2124,-0.06068 -0.2124,-0.13655c0,-0.09103 0.07585,-0.13655 0.28825,-0.13655c0.60685,0 1.72953,0.06068 1.79022,0.06068c0.07585,0 1.21371,-0.06068 1.75988,-0.06068c0.19722,0 0.28825,0.04552 0.28825,0.13655c0,0.07585 -0.06068,0.12137 -0.2124,0.13655c-0.12137,0.01517 -0.2124,0.01517 -0.34894,0.04552c-0.57651,0.07585 -0.62202,0.37929 -0.66754,0.94062c-0.04552,0.531 -0.01517,0.98614 -0.01517,3.56526l0,2.95841c0,1.51713 -0.01517,2.88256 0.07585,3.59561c0.07585,0.57651 0.15172,0.78891 0.66754,0.91028c0.25792,0.06068 0.66754,0.07585 0.74339,0.07585c0.18205,0.01517 0.2124,0.06068 0.2124,0.13655s-0.07585,0.13655 -0.27308,0.13655c-1.00131,0 -2.13915,-0.06068 -2.24535,-0.06068c-0.06068,0 -1.21371,0.06068 -1.75988,0.06068c-0.18205,0 -0.3186,-0.04552 -0.3186,-0.13655c0,-0.07585 0.07585,-0.13655 0.25792,-0.13655c0.09103,0 0.3186,-0.01517 0.47032,-0.06068c0.33377,-0.07585 0.39445,-0.47032 0.45514,-0.94062c0.09103,-0.71305 0.09103,-2.09365 0.09103,-3.56526l0,-2.95841l0.03035,0l0,-0.00001z"
                  />
                  <path
                    stroke="null"
                    id="svg_51"
                    d="m524.02071,69.613c0,-0.60685 0.06068,-0.80409 0.2124,-0.80409c0.13655,0 0.47032,0.39445 0.60685,0.531c0.18205,0.19722 2.89772,2.98876 5.65891,5.79545c1.53231,1.48679 3.48941,3.51975 4.00523,3.99006l-0.2124,-8.16218c-0.01517,-1.06199 -0.13655,-1.41093 -0.66754,-1.54748c-0.33377,-0.06068 -0.62202,-0.07585 -0.75857,-0.07585c-0.19722,0 -0.24274,-0.07585 -0.24274,-0.15172c0,-0.09103 0.15172,-0.12137 0.34894,-0.12137c0.84959,0 1.66885,0.06068 1.8509,0.06068c0.19722,0 0.80409,-0.06068 1.57783,-0.06068c0.2124,0 0.27308,0.01517 0.27308,0.12137c0,0.07585 -0.06068,0.13655 -0.18205,0.15172c-0.12137,0.01517 -0.27308,0.01517 -0.48549,0.06068c-0.45514,0.09103 -0.59169,0.28825 -0.59169,1.47163l-0.04552,9.86137c0,0.98614 -0.04552,1.07716 -0.18205,1.07716c-0.13655,0 -0.33377,-0.13655 -1.28956,-1.04682c-0.07585,-0.04552 -2.80669,-2.74601 -4.52106,-4.41487c-2.04813,-2.12399 -4.00523,-4.15695 -4.49072,-4.67277l0.25792,7.6767c0.04552,1.35025 0.15172,1.86608 0.65237,1.98745c0.3186,0.07585 0.65237,0.07585 0.80409,0.07585c0.15172,0 0.24274,0.06068 0.24274,0.13655c0,0.09103 -0.09103,0.13655 -0.3186,0.13655c-1.06199,0 -1.75988,-0.06068 -1.91158,-0.06068c-0.13655,0 -0.86477,0.06068 -1.71436,0.06068c-0.18205,0 -0.28825,-0.01517 -0.28825,-0.13655c0,-0.07585 0.07585,-0.13655 0.27308,-0.13655c0.13655,0 0.34894,0 0.60685,-0.07585c0.4248,-0.13655 0.531,-0.66754 0.531,-2.09365c0,-9.40623 0.03035,-6.37197 0,-9.6338l0.00001,0z"
                  />
                  <path
                    stroke="null"
                    id="svg_52"
                    d="m550.78295,80.21777c0,0.78891 -0.01517,0.80409 -0.24274,0.92546c-1.07716,0.54617 -2.65499,0.74339 -3.61078,0.74339c-1.27439,0 -3.74733,-0.09103 -5.74993,-1.75988c-1.06199,-0.87994 -2.12399,-2.53362 -2.12399,-4.7638c0,-2.67016 1.35025,-4.56657 2.95841,-5.53753c1.51713,-0.87994 3.18598,-1.00131 4.38452,-1.00131c1.25921,0 2.09365,0.15172 2.80669,0.27308c0.3186,0.06068 1.07716,0.15172 1.48679,0.18205c0.15172,0 0.15172,0.07585 0.15172,0.15172c0,0.24274 -0.13655,0.81925 -0.13655,2.54879c0,0.27308 -0.01517,0.34894 -0.15172,0.34894c-0.09103,0 -0.12137,-0.12137 -0.13655,-0.24274c0,-0.18205 -0.07585,-0.78891 -0.37929,-1.21371c-0.45514,-0.65237 -1.86608,-1.38059 -4.06592,-1.38059c-1.06199,0 -2.29087,0.04552 -3.61078,1.04682c-1.00131,0.75857 -1.65368,2.26053 -1.65368,4.20247c0,2.33639 1.27439,4.06592 1.79022,4.5514c1.28956,1.25921 2.74601,1.82056 4.46037,1.82056c0.54617,0 1.41093,-0.09103 1.86608,-0.33377c0.19722,-0.12137 0.33377,-0.3186 0.33377,-0.59169l0,-2.82187c0,-1.28956 -0.09103,-1.54748 -0.78891,-1.65368c-0.12137,-0.01517 -0.3186,-0.04552 -0.47032,-0.04552c-0.15172,0 -0.24274,-0.07585 -0.24274,-0.13655c0,-0.09103 0.07585,-0.13655 0.28825,-0.13655c0.78891,0 1.92676,0.04552 2.00262,0.04552c0.07585,0 1.24406,-0.04552 1.75988,-0.04552c0.19722,0 0.27308,0.04552 0.27308,0.13655c0,0.06068 -0.06068,0.13655 -0.24274,0.13655c-0.13655,0 -0.18205,0 -0.33377,0.01517c-0.47032,0.06068 -0.59169,0.40962 -0.62202,0.98614c-0.04552,0.57651 -0.04552,1.06199 -0.04552,1.75988l0,1.79022l0.04552,0l0.00004,0z"
                  />
                  <path
                    stroke="null"
                    id="svg_53"
                    d="m554.71233,81.44664c-0.25792,-0.12137 -0.25792,-0.19722 -0.25792,-0.66754c0,-0.91028 0.06068,-1.57783 0.07585,-1.8509c0.01517,-0.18205 0.06068,-0.27308 0.15172,-0.27308c0.09103,0 0.13655,0.06068 0.13655,0.19722c0,0.12137 0,0.34894 0.06068,0.59169c0.25792,1.27439 1.41093,1.75988 2.54879,1.75988c1.62333,0 2.41224,-1.12268 2.41224,-2.09365c0,-1.12268 -0.51582,-1.80538 -1.94193,-2.95841l-0.78891,-0.60685c-1.88125,-1.51713 -2.2757,-2.54879 -2.2757,-3.71698c0,-1.80538 1.42611,-3.01909 3.62595,-3.01909c0.68271,0 1.15302,0.06068 1.59299,0.15172c0.37929,0.07585 0.531,0.09103 0.66754,0.09103c0.13655,0 0.18205,0.04552 0.18205,0.12137c0,0.07585 -0.07585,0.75857 -0.07585,1.91158c0,0.28825 -0.04552,0.40962 -0.13655,0.40962c-0.09103,0 -0.12137,-0.07585 -0.13655,-0.2124c-0.01517,-0.18205 -0.06068,-0.59169 -0.24274,-0.92546c-0.09103,-0.18205 -0.54617,-0.92546 -2.19985,-0.92546c-1.18336,0 -2.0633,0.71305 -2.0633,1.88125c0,0.92546 0.47032,1.48679 2.09365,2.73084l0.45514,0.34894c2.04813,1.57783 2.57912,2.60947 2.57912,4.00523c0,0.71305 -0.28825,1.9571 -1.48679,2.79152c-0.75857,0.48549 -1.71436,0.68271 -2.65499,0.68271c-0.81925,0.01517 -1.57783,-0.09103 -2.32122,-0.4248l0.00001,0z"
                  />
                  <path
                    stroke="null"
                    id="svg_54"
                    className="st0"
                    d="m567.83553,76.0153c0,2.88256 0.07585,4.14177 0.4248,4.49072c0.3186,0.3186 0.81925,0.45514 2.35155,0.45514c1.04682,0 1.91158,-0.01517 2.3819,-0.59169c0.25792,-0.3186 0.45514,-0.80409 0.51582,-1.18336c0.01517,-0.15172 0.06068,-0.25792 0.18205,-0.25792c0.09103,0 0.12137,0.07585 0.12137,0.28825s-0.13655,1.39576 -0.28825,1.9571c-0.13655,0.45514 -0.19722,0.531 -1.24406,0.531c-1.68402,0 -3.35286,-0.12137 -5.26446,-0.12137c-0.60685,0 -1.19854,0.06068 -1.92676,0.06068c-0.2124,0 -0.3186,-0.04552 -0.3186,-0.15172c0,-0.06068 0.04552,-0.12137 0.15172,-0.12137c0.18205,0 0.40962,-0.04552 0.59169,-0.07585c0.39445,-0.07585 0.48549,-0.51582 0.57651,-1.07716c0.09103,-0.81925 0.09103,-2.3819 0.09103,-4.26315l0,-3.44389c0,-3.06461 0,-3.61078 -0.04552,-4.2328c-0.04552,-0.66754 -0.19722,-0.98614 -0.84959,-1.12268c-0.15172,-0.04552 -0.48549,-0.06068 -0.66754,-0.06068c-0.07585,0 -0.15172,-0.04552 -0.15172,-0.12137c0,-0.12137 0.09103,-0.15172 0.3186,-0.15172c0.87994,0 2.12399,0.06068 2.21502,0.06068c0.09103,0 1.53231,-0.06068 2.12399,-0.06068c0.2124,0 0.3186,0.04552 0.3186,0.15172c0,0.07585 -0.07585,0.12137 -0.15172,0.12137c-0.13655,0 -0.40962,0.01517 -0.65237,0.06068c-0.57651,0.09103 -0.72822,0.4248 -0.75857,1.12268c-0.04552,0.62202 -0.04552,1.18336 -0.04552,4.2328l0,3.50458l0.00001,0.00001z"
                    fill="#00BCD4"
                  />
                  <path
                    stroke="null"
                    id="svg_64"
                    className="st0"
                    d="m575.7398,75.31741c0,-2.60947 2.01779,-6.52367 6.87262,-6.52367c3.88386,0 6.85744,2.32122 6.85744,6.26577c0,3.74733 -2.76119,6.81194 -6.94847,6.81194c-4.82449,0.01517 -6.78159,-3.56526 -6.78159,-6.55402l0,-0.00001zm11.86398,0.24274c0,-3.94455 -2.42742,-6.1444 -5.12791,-6.1444c-2.73084,0 -4.93069,1.68402 -4.93069,5.401c0,3.85352 2.13915,6.4023 5.43134,6.4023c1.33508,0 4.62726,-0.66754 4.62726,-5.65891z"
                    fill="#00BCD4"
                  />
                  <path
                    stroke="null"
                    id="svg_67"
                    className="st0"
                    d="m603.63989,80.21777c0,0.78891 -0.01517,0.80409 -0.24274,0.92546c-1.07716,0.54617 -2.65499,0.74339 -3.61078,0.74339c-1.27439,0 -3.74733,-0.09103 -5.74993,-1.75988c-1.06199,-0.87994 -2.12399,-2.53362 -2.12399,-4.7638c0,-2.67016 1.35025,-4.56657 2.95841,-5.53753c1.51713,-0.87994 3.18598,-1.00131 4.38452,-1.00131c1.25921,0 2.09365,0.15172 2.80669,0.27308c0.3186,0.06068 1.07716,0.15172 1.48679,0.18205c0.15172,0 0.15172,0.07585 0.15172,0.15172c0,0.24274 -0.13655,0.81925 -0.13655,2.54879c0,0.27308 -0.01517,0.34894 -0.15172,0.34894c-0.09103,0 -0.12137,-0.12137 -0.13655,-0.24274c0,-0.18205 -0.07585,-0.78891 -0.37929,-1.21371c-0.45514,-0.65237 -1.86608,-1.38059 -4.06592,-1.38059c-1.06199,0 -2.29087,0.04552 -3.61078,1.04682c-1.00131,0.75857 -1.65368,2.26053 -1.65368,4.20247c0,2.33639 1.27439,4.06592 1.79022,4.5514c1.28956,1.25921 2.74601,1.82056 4.46037,1.82056c0.54617,0 1.41093,-0.09103 1.86608,-0.33377c0.19722,-0.12137 0.33377,-0.3186 0.33377,-0.59169l0,-2.82187c0,-1.28956 -0.09103,-1.54748 -0.78891,-1.65368c-0.12137,-0.01517 -0.3186,-0.04552 -0.47032,-0.04552c-0.15172,0 -0.24274,-0.07585 -0.24274,-0.13655c0,-0.09103 0.07585,-0.13655 0.28825,-0.13655c0.78891,0 1.92676,0.04552 2.00262,0.04552c0.07585,0 1.24406,-0.04552 1.75988,-0.04552c0.19722,0 0.27308,0.04552 0.27308,0.13655c0,0.06068 -0.06068,0.13655 -0.24274,0.13655c-0.13655,0 -0.18205,0 -0.33377,0.01517c-0.47032,0.06068 -0.59169,0.40962 -0.62202,0.98614c-0.04552,0.57651 -0.04552,1.06199 -0.04552,1.75988l0,1.79022l0.04552,0l0.00004,0z"
                    fill="#00BCD4"
                  />
                </g>
                <g stroke="null" id="svg_83">
                  <circle
                    stroke="null"
                    id="svg_85"
                    className="st0"
                    cx="476.61027"
                    cy="74.10372"
                    r="0.81923"
                    fill="#00BCD4"
                  />
                  <path
                    stroke="null"
                    id="svg_86"
                    className="st0"
                    d="m478.08189,73.75477l2.82187,0c0,0 0,0 0,0c0,-0.06068 0,-0.12137 0.01517,-0.19722c0,-0.15172 0.01517,-0.28825 0.01517,-0.43997c0,-2.21502 -0.66754,-4.26315 -1.82056,-5.96233c-0.09103,-0.13655 -0.19722,-0.28825 -0.30342,-0.4248c-0.51582,-0.68271 -1.10751,-1.30473 -1.75988,-1.8509c-1.83573,-1.51713 -4.20247,-2.42742 -6.78159,-2.42742s-4.94586,0.91028 -6.78159,2.42742c-0.65237,0.54617 -1.24406,1.16819 -1.75988,1.8509c-0.1062,0.13655 -0.19722,0.27308 -0.30342,0.4248c-1.15302,1.69918 -1.82056,3.74733 -1.82056,5.96233c0,0.16688 0,0.33377 0.01517,0.50065c0,0.04552 0,0.1062 0.01517,0.15172c0,0.12137 0.01517,0.22757 0.03035,0.34894c0,0.06068 0.01517,0.12137 0.01517,0.18205c0.01517,0.1062 0.03035,0.22757 0.04552,0.33377c0.01517,0.06068 0.01517,0.1062 0.03035,0.16688c0.01517,0.13655 0.04552,0.27308 0.07585,0.4248c0,0.01517 0,0.04552 0.01517,0.06068c0.03035,0.15172 0.07585,0.3186 0.1062,0.47032c0.01517,0.04552 0.03035,0.1062 0.04552,0.15172c0.03035,0.1062 0.06068,0.2124 0.09103,0.30342c0.01517,0.06068 0.03035,0.12137 0.06068,0.18205c0.03035,0.09103 0.06068,0.19722 0.09103,0.28825c0.01517,0.06068 0.04552,0.12137 0.06068,0.16688c0.04552,0.1062 0.07585,0.2124 0.12137,0.3186c0.01517,0.04552 0.03035,0.09103 0.04552,0.12137c0.06068,0.13655 0.12137,0.27308 0.18205,0.40962c0.03035,0.06068 0.06068,0.12137 0.09103,0.16688c0.04552,0.07585 0.07585,0.16688 0.12137,0.24274c0.03035,0.06068 0.07585,0.12137 0.1062,0.19722c0.04552,0.07585 0.07585,0.15172 0.12137,0.2124c0.04552,0.06068 0.07585,0.13655 0.12137,0.19722c0.04552,0.07585 0.09103,0.13655 0.13655,0.2124c0.04552,0.07585 0.1062,0.15172 0.15172,0.22757c0.07585,0.1062 0.13655,0.19722 0.2124,0.30342c0.04552,0.07585 0.1062,0.13655 0.15172,0.19722c0.04552,0.04552 0.07585,0.1062 0.12137,0.15172c0.06068,0.07585 0.1062,0.13655 0.16688,0.2124c0.04552,0.04552 0.07585,0.09103 0.12137,0.13655c0.06068,0.07585 0.12137,0.13655 0.18205,0.2124c0.03035,0.04552 0.07585,0.07585 0.1062,0.12137c0.24274,0.24274 0.48549,0.48549 0.74339,0.71305c0.03035,0.03035 0.06068,0.04552 0.09103,0.07585c0.07585,0.07585 0.16688,0.13655 0.24274,0.19722c0.03035,0.03035 0.06068,0.04552 0.1062,0.07585c0.09103,0.06068 0.16688,0.13655 0.25792,0.19722c0.03035,0.01517 0.04552,0.03035 0.07585,0.06068c0.30342,0.22757 0.63719,0.4248 0.97096,0.62202c0.01517,0 0.01517,0.01517 0.03035,0.01517c0.1062,0.06068 0.2124,0.12137 0.3186,0.16688c0.03035,0.01517 0.04552,0.03035 0.07585,0.04552c0.1062,0.06068 0.2124,0.1062 0.3186,0.15172c0.01517,0.01517 0.04552,0.01517 0.06068,0.03035c0.36412,0.16688 0.74339,0.3186 1.12268,0.43997l0,-4.05075c0,-0.68271 -0.54617,-1.22888 -1.22888,-1.22888l-0.37929,0c-0.19722,0.60685 -0.77374,1.04682 -1.44128,1.04682c-0.83442,0 -1.51713,-0.68271 -1.51713,-1.51713s0.68271,-1.51713 1.51713,-1.51713c0.75857,0 1.38059,0.56134 1.50196,1.28956l0.33377,0c1.06199,0 1.94193,0.86477 1.94193,1.94193l0,4.24797c0,0 0,0 0,0c0.59169,0.15172 1.19854,0.24274 1.82056,0.28825l0,-0.25792l0,-15.36856l-4.70312,0c-0.66754,0 -1.21371,0.54617 -1.21371,1.21371l0,0.87994c0.50065,0.24274 0.83442,0.74339 0.83442,1.33508c0,0.81925 -0.66754,1.47163 -1.47163,1.47163c-0.81925,0 -1.47163,-0.66754 -1.47163,-1.47163c0,-0.59169 0.34894,-1.09234 0.83442,-1.33508l0,-0.87994c0,-1.36541 1.10751,-2.47292 2.47292,-2.47292l9.90688,0c0.34894,0 0.63719,0.28825 0.63719,0.63719s-0.28825,0.63719 -0.63719,0.63719l-3.99006,0l0,12.47084l-0.01517,3.15564c5.23411,-0.2124 9.48208,-4.20247 10.11928,-9.31521l-2.74601,0c-0.16688,0.66754 -0.75857,1.16819 -1.47163,1.16819c-0.83442,0 -1.51713,-0.68271 -1.51713,-1.51713c0,-0.83442 0.68271,-1.51713 1.51713,-1.51713c0.71305,-0.03035 1.31991,0.47032 1.47163,1.13786l0.00004,0.00007zm-1.65368,5.03689c0.33377,0 0.62202,0.27308 0.62202,0.62202c0,0.33377 -0.27308,0.62202 -0.62202,0.62202l-2.63982,0c-1.21371,0 -2.19985,-0.98614 -2.19985,-2.19985l0,-6.49334c0,-0.33377 0.27308,-0.62202 0.62202,-0.62202c0.33377,0 0.62202,0.27308 0.62202,0.62202l0,6.49334c0,0.531 0.43997,0.97096 0.97096,0.97096l2.62464,0l0,-0.01517l0.00001,0.00001z"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_87"
                    className="st0"
                    cx="462.98641"
                    cy="71.5701"
                    r="0.74339"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_88"
                    className="st0"
                    cx="463.91186"
                    cy="77.51726"
                    r="0.81923"
                    fill="#00BCD4"
                  />
                </g>
              </g>
              <g stroke="null" id="svg_119">
                <rect
                  stroke="null"
                  fill="#e7eded"
                  x="179.39475"
                  y="190.83072"
                  width="57.64663"
                  height="77.33086"
                  id="svg_24"
                />
                <rect
                  stroke="null"
                  fill="#d3d7d8"
                  x="198.95092"
                  y="241.84682"
                  width="33.83911"
                  height="21.21315"
                  id="svg_89"
                />
                <g stroke="null" id="svg_116">
                  <circle
                    stroke="null"
                    id="svg_90"
                    className="st0"
                    cx="217.17727"
                    cy="214.02571"
                    r="1.20278"
                    fill="#00BCD4"
                  />
                  <path
                    stroke="null"
                    id="svg_103"
                    className="st0"
                    d="m219.3378,213.51341l4.1429,0c0,0 0,0 0,0c0,-0.08909 0,-0.17819 0.02228,-0.28955c0,-0.22274 0.02228,-0.42319 0.02228,-0.64594c0,-3.25196 -0.98004,-6.2589 -2.67283,-8.75354c-0.13364,-0.20047 -0.28955,-0.42319 -0.44547,-0.62366c-0.7573,-1.00232 -1.62598,-1.91553 -2.58375,-2.71738c-2.69511,-2.22736 -6.16981,-3.56379 -9.95632,-3.56379s-7.26121,1.33643 -9.95632,3.56379c-0.95777,0.80185 -1.82645,1.71506 -2.58375,2.71738c-0.15591,0.20047 -0.28955,0.40092 -0.44547,0.62366c-1.69279,2.49464 -2.67283,5.5016 -2.67283,8.75354c0,0.245 0,0.49002 0.02228,0.73502c0,0.06683 0,0.15591 0.02228,0.22274c0,0.17819 0.02228,0.33411 0.04455,0.5123c0,0.08909 0.02228,0.17819 0.02228,0.26728c0.02228,0.15591 0.04455,0.33411 0.06683,0.49002c0.02228,0.08909 0.02228,0.15591 0.04455,0.245c0.02228,0.20047 0.06683,0.40092 0.11136,0.62366c0,0.02228 0,0.06683 0.02228,0.08909c0.04455,0.22274 0.11136,0.46774 0.15591,0.69049c0.02228,0.06683 0.04455,0.15591 0.06683,0.22274c0.04455,0.15591 0.08909,0.31183 0.13364,0.44547c0.02228,0.08909 0.04455,0.17819 0.08909,0.26728c0.04455,0.13364 0.08909,0.28955 0.13364,0.42319c0.02228,0.08909 0.06683,0.17819 0.08909,0.245c0.06683,0.15591 0.11136,0.31183 0.17819,0.46774c0.02228,0.06683 0.04455,0.13364 0.06683,0.17819c0.08909,0.20047 0.17819,0.40092 0.26728,0.60138c0.04455,0.08909 0.08909,0.17819 0.13364,0.245c0.06683,0.11136 0.11136,0.245 0.17819,0.35638c0.04455,0.08909 0.11136,0.17819 0.15591,0.28955c0.06683,0.11136 0.11136,0.22274 0.17819,0.31183c0.06683,0.08909 0.11136,0.20047 0.17819,0.28955c0.06683,0.11136 0.13364,0.20047 0.20047,0.31183c0.06683,0.11136 0.15591,0.22274 0.22274,0.33411c0.11136,0.15591 0.20047,0.28955 0.31183,0.44547c0.06683,0.11136 0.15591,0.20047 0.22274,0.28955c0.06683,0.06683 0.11136,0.15591 0.17819,0.22274c0.08909,0.11136 0.15591,0.20047 0.245,0.31183c0.06683,0.06683 0.11136,0.13364 0.17819,0.20047c0.08909,0.11136 0.17819,0.20047 0.26728,0.31183c0.04455,0.06683 0.11136,0.11136 0.15591,0.17819c0.35638,0.35638 0.71277,0.71277 1.0914,1.04685c0.04455,0.04455 0.08909,0.06683 0.13364,0.11136c0.11136,0.11136 0.245,0.20047 0.35638,0.28955c0.04455,0.04455 0.08909,0.06683 0.15591,0.11136c0.13364,0.08909 0.245,0.20047 0.37866,0.28955c0.04455,0.02228 0.06683,0.04455 0.11136,0.08909c0.44547,0.33411 0.93549,0.62366 1.42551,0.91321c0.02228,0 0.02228,0.02228 0.04455,0.02228c0.15591,0.08909 0.31183,0.17819 0.46774,0.245c0.04455,0.02228 0.06683,0.04455 0.11136,0.06683c0.15591,0.08909 0.31183,0.15591 0.46774,0.22274c0.02228,0.02228 0.06683,0.02228 0.08909,0.04455c0.53457,0.245 1.0914,0.46774 1.64826,0.64594l0,-5.94707c0,-1.00232 -0.80185,-1.80417 -1.80417,-1.80417l-0.55685,0c-0.28955,0.89094 -1.13596,1.53687 -2.116,1.53687c-1.22504,0 -2.22736,-1.00232 -2.22736,-2.22736s1.00232,-2.22736 2.22736,-2.22736c1.11368,0 2.02689,0.82413 2.20509,1.89326l0.49002,0c1.55915,0 2.85102,1.2696 2.85102,2.85102l0,6.23662c0,0 0,0 0,0c0.86868,0.22274 1.75962,0.35638 2.67283,0.42319l0,-0.37866l0,-22.5632l-6.90483,0c-0.98004,0 -1.78189,0.80185 -1.78189,1.78189l0,1.29187c0.73502,0.35638 1.22504,1.0914 1.22504,1.96009c0,1.20277 -0.98004,2.16055 -2.16055,2.16055c-1.20277,0 -2.16055,-0.98004 -2.16055,-2.16055c0,-0.86868 0.5123,-1.6037 1.22504,-1.96009l0,-1.29187c0,-2.00462 1.62598,-3.6306 3.6306,-3.6306l14.54469,0c0.5123,0 0.93549,0.42319 0.93549,0.93549s-0.42319,0.93549 -0.93549,0.93549l-5.85796,0l0,18.30894l-0.02228,4.63292c7.68441,-0.31183 13.92103,-6.16981 14.85652,-13.67603l-4.03153,0c-0.245,0.98004 -1.11368,1.71506 -2.16055,1.71506c-1.22504,0 -2.22736,-1.00232 -2.22736,-2.22736c0,-1.22504 1.00232,-2.22736 2.22736,-2.22736c1.04685,-0.04455 1.93781,0.69049 2.16055,1.67053l0.00006,0.0001zm-2.42783,7.39485c0.49002,0 0.91321,0.40092 0.91321,0.91321c0,0.49002 -0.40092,0.91321 -0.91321,0.91321l-3.87562,0c-1.78189,0 -3.22968,-1.44779 -3.22968,-3.22968l0,-9.53313c0,-0.49002 0.40092,-0.91321 0.91321,-0.91321c0.49002,0 0.91321,0.40092 0.91321,0.91321l0,9.53313c0,0.77957 0.64594,1.42551 1.42551,1.42551l3.85334,0l0,-0.02228l0.00002,0.00002z"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_105"
                    className="st0"
                    cx="197.17554"
                    cy="210.306"
                    r="1.09139"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_115"
                    className="st0"
                    cx="198.53422"
                    cy="219.03726"
                    r="1.20278"
                    fill="#00BCD4"
                  />
                </g>
              </g>
              <g stroke="null" id="svg_145">
                <rect
                  stroke="null"
                  fill="#e7eded"
                  x="858.12059"
                  y="47.43196"
                  width="36.40211"
                  height="48.83211"
                  id="svg_138"
                />
                <rect
                  stroke="null"
                  fill="#d3d7d8"
                  x="870.46972"
                  y="79.64708"
                  width="21.36838"
                  height="13.39546"
                  id="svg_139"
                />
                <g stroke="null" id="svg_144">
                  <circle
                    stroke="null"
                    id="svg_140"
                    className="st0"
                    cx="881.97912"
                    cy="62.07889"
                    r="0.75947"
                    fill="#00BCD4"
                  />
                  <path
                    stroke="null"
                    id="svg_141"
                    className="st0"
                    d="m883.34343,61.75538l2.61612,0c0,0 0,0 0,0c0,-0.05625 0,-0.11252 0.01407,-0.18284c0,-0.14066 0.01406,-0.26723 0.01406,-0.40789c0,-2.05351 -0.61886,-3.9523 -1.68781,-5.52759c-0.08439,-0.12659 -0.18284,-0.26723 -0.2813,-0.39382c-0.47821,-0.63294 -1.02675,-1.2096 -1.63155,-1.71595c-1.70188,-1.40651 -3.89605,-2.25042 -6.28712,-2.25042s-4.58524,0.84391 -6.28712,2.25042c-0.6048,0.50635 -1.15334,1.08301 -1.63156,1.71595c-0.09845,0.12659 -0.18284,0.25317 -0.28129,0.39382c-1.06895,1.57529 -1.68781,3.47409 -1.68781,5.52759c0,0.15471 0,0.30944 0.01406,0.46415c0,0.0422 0,0.09845 0.01407,0.14065c0,0.11252 0.01407,0.21098 0.02814,0.32351c0,0.05625 0.01407,0.11252 0.01407,0.16877c0.01407,0.09845 0.02813,0.21098 0.0422,0.30944c0.01407,0.05625 0.01407,0.09845 0.02814,0.15471c0.01407,0.12658 0.0422,0.25317 0.07032,0.39382c0,0.01407 0,0.0422 0.01407,0.05626c0.02814,0.14066 0.07033,0.29537 0.09845,0.43602c0.01407,0.0422 0.02814,0.09846 0.0422,0.14066c0.02814,0.09845 0.05626,0.19691 0.08439,0.2813c0.01407,0.05625 0.02814,0.11252 0.05626,0.16877c0.02814,0.08439 0.05626,0.18285 0.08439,0.26723c0.01407,0.05626 0.0422,0.11252 0.05626,0.15471c0.0422,0.09845 0.07033,0.19692 0.11252,0.29537c0.01407,0.0422 0.02814,0.08439 0.0422,0.11252c0.05625,0.12659 0.11252,0.25317 0.16877,0.37976c0.02814,0.05626 0.05626,0.11252 0.08439,0.15471c0.0422,0.07032 0.07032,0.15471 0.11252,0.22504c0.02813,0.05625 0.07032,0.11252 0.09845,0.18284c0.0422,0.07033 0.07032,0.14066 0.11252,0.19692c0.0422,0.05625 0.07032,0.12659 0.11252,0.18284c0.0422,0.07033 0.08439,0.12659 0.12659,0.19692c0.0422,0.07032 0.09845,0.14065 0.14066,0.21098c0.07032,0.09845 0.12658,0.18284 0.19691,0.2813c0.0422,0.07032 0.09845,0.12659 0.14066,0.18284c0.0422,0.0422 0.07032,0.09845 0.11252,0.14066c0.05625,0.07032 0.09845,0.12659 0.15471,0.19691c0.0422,0.0422 0.07032,0.08439 0.11252,0.12659c0.05625,0.07033 0.11252,0.12659 0.16877,0.19692c0.02814,0.0422 0.07033,0.07032 0.09846,0.11252c0.22504,0.22504 0.45009,0.45009 0.68919,0.66105c0.02814,0.02814 0.05626,0.0422 0.08439,0.07033c0.07033,0.07032 0.15471,0.12659 0.22504,0.18284c0.02814,0.02814 0.05626,0.0422 0.09846,0.07033c0.08439,0.05626 0.1547,0.12659 0.23911,0.18284c0.02814,0.01407 0.0422,0.02814 0.07033,0.05626c0.2813,0.21098 0.59073,0.39382 0.90017,0.57666c0.01406,0 0.01406,0.01407 0.02813,0.01407c0.09845,0.05626 0.19692,0.11252 0.29537,0.15471c0.02813,0.01407 0.0422,0.02814 0.07032,0.0422c0.09846,0.05625 0.19692,0.09845 0.29537,0.14065c0.01407,0.01407 0.0422,0.01407 0.05626,0.02814c0.33757,0.15471 0.68919,0.29537 1.04082,0.40789l0,-3.75539c0,-0.63294 -0.50635,-1.13928 -1.13928,-1.13928l-0.35163,0c-0.18284,0.5626 -0.71732,0.97049 -1.33618,0.97049c-0.77358,0 -1.40652,-0.63293 -1.40652,-1.40651s0.63294,-1.40651 1.40652,-1.40651c0.70325,0 1.27992,0.52041 1.39244,1.19553l0.30944,0c0.98456,0 1.80033,0.80171 1.80033,1.80033l0,3.93823c0,0 0,0 0,0c0.54854,0.14066 1.11115,0.22504 1.68781,0.26723l0,-0.23911l0,-14.24798l-4.36019,0c-0.61887,0 -1.12521,0.50635 -1.12521,1.12521l0,0.81578c0.46415,0.22504 0.77358,0.68919 0.77358,1.23774c0,0.7595 -0.61887,1.36432 -1.36433,1.36432c-0.7595,0 -1.36432,-0.61887 -1.36432,-1.36432c0,-0.54855 0.3235,-1.01269 0.77358,-1.23774l0,-0.81578c0,-1.26586 1.02675,-2.29262 2.29261,-2.29262l9.18453,0c0.3235,0 0.59073,0.26723 0.59073,0.59074s-0.26723,0.59073 -0.59073,0.59073l-3.69913,0l0,11.56154l-0.01406,2.92555c4.85246,-0.19691 8.7907,-3.89605 9.38144,-8.63599l-2.54579,0c-0.15471,0.61886 -0.70325,1.08301 -1.36432,1.08301c-0.77358,0 -1.40652,-0.63294 -1.40652,-1.40652c0,-0.77357 0.63294,-1.40651 1.40652,-1.40651c0.66105,-0.02814 1.22367,0.43602 1.36432,1.05489l0.00004,0.00006zm-1.5331,4.66963c0.30943,0 0.57666,0.25317 0.57666,0.57666c0,0.30944 -0.25317,0.57667 -0.57666,0.57667l-2.44734,0c-1.12521,0 -2.03945,-0.91424 -2.03945,-2.03945l0,-6.01988c0,-0.30943 0.25317,-0.57666 0.57666,-0.57666c0.30944,0 0.57667,0.25317 0.57667,0.57666l0,6.01988c0,0.49228 0.40788,0.90017 0.90016,0.90017l2.43327,0l0,-0.01407l0.00001,0.00001z"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_142"
                    className="st0"
                    cx="869.34863"
                    cy="59.73001"
                    r="0.68916"
                    fill="#00BCD4"
                  />
                  <circle
                    stroke="null"
                    id="svg_143"
                    className="st0"
                    cx="870.20659"
                    cy="65.24354"
                    r="0.75947"
                    fill="#00BCD4"
                  />
                </g>
              </g>
              <g stroke="null" id="svg_154">
                <path
                  stroke="null"
                  id="svg_153"
                  d="m724.70207,550.91101l-14.9919,0c-0.95537,0 -1.72983,0.77447 -1.72983,1.72983l0,12.68546c0,0.95537 0.77446,1.72983 1.72983,1.72983l14.9919,0c0.95537,0 1.72983,-0.77446 1.72983,-1.72983l0,-12.68546c0,-0.95537 -0.77446,-1.72983 -1.72983,-1.72983zm-8.64917,13.83868l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967zm0,-5.76611l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967zm8.07256,5.76611l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967zm0,-5.76611l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967z"
                  fill="currentColor"
                />
              </g>
              <text
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="14"
                id="svg_155"
                y="564.69774"
                x="731.46244"
                stroke-width="0"
                stroke="#000000"
                fill="#000000"
              >
                {this.calculateGroundReading(this.state.lastReading)} cm
              </text>
              <g stroke="null" id="svg_157">
                <path
                  stroke="null"
                  id="svg_156"
                  d="m1101.21214,247.7245l-14.9919,0c-0.95537,0 -1.72983,0.77446 -1.72983,1.72983l0,12.68546c0,0.95537 0.77446,1.72983 1.72983,1.72983l14.9919,0c0.95538,0 1.72983,-0.77446 1.72983,-1.72983l0,-12.68546c0,-0.95537 -0.77445,-1.72983 -1.72983,-1.72983zm-8.64917,13.83868l-5.76612,0l0,-3.45967l5.76612,0l0,3.45967zm0,-5.76612l-5.76612,0l0,-3.45967l5.76612,0l0,3.45967zm8.07256,5.76612l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967zm0,-5.76612l-5.76611,0l0,-3.45967l5.76611,0l0,3.45967z"
                  fill="currentColor"
                />
              </g>
              <text
                xmlSpace="preserve"
                text-anchor="start"
                font-family="'Montserrat'"
                font-size="14"
                id="svg_158"
                y="261.51124"
                x="1107.97251"
                stroke-width="0"
                stroke="#000000"
                fill="#000000"
              >
                {this.calculateTowerReading(this.state.lastReading)} cm
              </text>
            </g>
            <defs stroke="null">
              <linearGradient
                stroke="null"
                spreadMethod="pad"
                y2="0"
                x2="1"
                y1="0"
                x1="0"
                id="svg_136"
              >
                <stop
                  stroke="null"
                  offset="0"
                  stop-opacity="0.99219"
                  stop-color={
                    this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff7c7c'
                  }
                />
                <stop
                  stroke="null"
                  offset="1"
                  stop-opacity="0.99609"
                  stop-color={
                    this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff5656'
                  }
                />
              </linearGradient>
              <linearGradient stroke="null" y2="0" x2="1" y1="0" x1="0" id="svg_137">
                <stop
                  stroke="null"
                  stop-opacity="0.99609"
                  offset="0"
                  stop-color={
                    this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff7c7c'
                  }
                />
                <stop
                  stroke="null"
                  offset="1"
                  stop-opacity="0.99609"
                  stop-color={
                    this.props.relaySwitchStatus ? this.state.activityColorHex : '#ff5656'
                  }
                />
              </linearGradient>
              <linearGradient
                stroke="null"
                spreadMethod="pad"
                y2="0"
                x2="1"
                y1="0"
                x1="0"
                id="svg_159"
              >
                <stop stroke="null" stop-opacity="0.99219" offset="0" stop-color="#7f0000" />
                <stop stroke="null" offset="0.54688" stop-color="#ff5656" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </>
    );
  }
}

interface SvgPumpAssetProps extends WithTranslation {
  towerDevice: PumpStationDeviceInfo;
  towerContainerCapacity: number;
  relaySwitchStatus: boolean;
}

interface SvgPumpAssetState {
  sensor1Height: number;
  sensor1Y: number;
  towerPercentFilled: number;
  sensor2Height: number;
  sensor2Y: number;
  groundPercentFilled: number;
  activityColorIndex: number;
  activityColorHex: string;
  overflowColorHex: string;
  lastReading: number;
}

export default withTranslation()(SvgPOC);
